import React, { useContext } from 'react';
import classNames from 'classnames';
import s from './wide-content.module.css';
import { context } from '../utils';
const WideContent = ({ children, onScroll, scrollable = false, header = false, footer = false }) => {
    const { size, mobile, dataTest } = useContext(context);
    const ignoreScroll = scrollable ? { 'data-scroll-lock-ignore': '' } : {};
    return (React.createElement("div", Object.assign({ className: classNames(s.box, s[size], {
            [s.header]: header,
            [s.footer]: footer,
            [s.scrollable]: scrollable,
            [s.mobile]: mobile,
        }), "data-test": dataTest && `${dataTest}-wide-content`, onScroll: onScroll }, ignoreScroll), children));
};
export default WideContent;
//# sourceMappingURL=wide-content.js.map